<!-- Page Wrapper -->
<div id="wrapper">
  <app-sidebar></app-sidebar>

  <!-- End of Sidebar -->

  <!-- Content Wrapper -->
  <div id="content-wrapper" class="d-flex flex-column">

    <!-- Main Content -->
    <div id="content">

      <!-- Topbar -->
      <app-header></app-header>
      <!-- End of Topbar -->

      <!-- Begin Page Content -->
      <div class="container-fluid">


        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">Customers</h1>
          <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" data-toggle="modal"
            data-target="#addcustomers"><i class="fas fa-plus fa-sm text-white-50"></i> Add Customers</a>
        </div>


        <!-- DataTales Example -->
        <div class="card shadow mb-4">
          <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Customers</h6>
          </div>
          <div class="card-body">

            <div class="table-responsive">
              <div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4">
                <div class="row">
                  <div class="col-sm-12 col-md-6">
                    <div class="dataTables_length" id="dataTable_length">
                      <label>Show <select name="dataTable_length" aria-controls="dataTable"
                          class="custom-select custom-select-sm form-control form-control-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select> entries</label>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-6">
                    <div id="dataTable_filter" class="dataTables_filter"><label>Search:<input type="search"
                          class="form-control form-control-sm" placeholder="" aria-controls="dataTable"></label>
                    </div>
                  </div>
                </div>
              </div>

              <table class="table table-striped table-bordered">
                <thead>
                  <tr class="bg-primary text-white">
                    <th>Sr#</th>
                    <th>User Name</th>
                    <th>Phone No.</th>
                    <th>Email</th>
                    <th>Address</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Smith</td>
                    <td>7853435678</td>
                    <td>smith@gmail.com</td>
                    <td> amet salami venison chicken flank fatback</td>
                    <td align="center">
                      <a href="#" class="text-primary" data-toggle="modal" data-target="#customereditModal"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="#" class="text-danger" data-toggle="modal" data-target="#deleteModal"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Clark</td>
                    <td>8657868698</td>
                    <td>smith@gmail.com</td>
                    <td> amet salami venison chicken flank fatback</td>
                    <td align="center">
                      <a href="#" class="text-primary" data-toggle="modal" data-target="#customereditModal"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="#" class="text-danger" data-toggle="modal" data-target="#deleteModal"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                  <tr>
                    <td>3</td>
                    <td>ken</td>
                    <td>8657868698</td>
                    <td>smith@gmail.com</td>
                    <td> amet salami venison chicken flank fatback</td>
                    <td align="center">
                      <a href="#" class="text-primary" data-toggle="modal" data-target="#customereditModal"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="#" class="text-danger" data-toggle="modal" data-target="#deleteModal"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Clark</td>
                    <td>8657868698</td>
                    <td>smith@gmail.com</td>
                    <td> amet salami venison chicken flank fatback</td>
                    <td align="center">
                      <a href="#" class="text-primary" data-toggle="modal" data-target="#customereditModal"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="#" class="text-danger" data-toggle="modal" data-target="#deleteModal"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Clark</td>
                    <td>8657868698</td>
                    <td>smith@gmail.com</td>
                    <td> amet salami venison chicken flank fatback</td>
                    <td align="center">
                      <a href="#" class="text-primary" data-toggle="modal" data-target="#customereditModal"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="#" class="text-danger" data-toggle="modal" data-target="#deleteModal"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Clark</td>
                    <td>8657868698</td>
                    <td>smith@gmail.com</td>
                    <td> amet salami venison chicken flank fatback</td>
                    <td align="center">
                      <a href="#" class="text-primary" data-toggle="modal" data-target="#customereditModal"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="#" class="text-danger" data-toggle="modal" data-target="#deleteModal"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Clark</td>
                    <td>8657868698</td>
                    <td>smith@gmail.com</td>
                    <td> amet salami venison chicken flank fatback</td>
                    <td align="center">
                      <a href="#" class="text-primary" data-toggle="modal" data-target="#customereditModal"><i
                          class="fa fa-fw fa-edit"></i> Edit</a> |
                      <a href="#" class="text-danger" data-toggle="modal" data-target="#deleteModal"><i
                          class="fa fa-fw fa-trash"></i> Delete</a>
                    </td>

                  </tr>
                </tbody>
              </table>






            </div>

            <div class="row">
              <div class="col-sm-12 col-md-5">
                <div class="dataTables_info" id="dataTable_info" role="status" aria-live="polite">Showing 1 to 10 of 57
                  entries</div>
              </div>
              <div class="col-sm-12 col-md-7">
                <div class="dataTables_paginate paging_simple_numbers" id="dataTable_paginate">
                  <ul class="pagination">
                    <li class="paginate_button page-item previous disabled" id="dataTable_previous"><a href="javascript:void(0);"
                        aria-controls="dataTable" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>
                    <li class="paginate_button page-item active"><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="1"
                        tabindex="0" class="page-link">1</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="2"
                        tabindex="0" class="page-link">2</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="3"
                        tabindex="0" class="page-link">3</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="4"
                        tabindex="0" class="page-link">4</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="5"
                        tabindex="0" class="page-link">5</a></li>
                    <li class="paginate_button page-item "><a href="javascript:void(0);" aria-controls="dataTable" data-dt-idx="6"
                        tabindex="0" class="page-link">6</a></li>
                    <li class="paginate_button page-item next" id="dataTable_next"><a href="javascript:void(0);" aria-controls="dataTable"
                        data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- /.container-fluid -->




    </div>
    <!-- End of Main Content -->

    <!-- Footer -->
    <app-footer></app-footer>
    <!-- End of Footer -->

  </div>
  <!-- End of Content Wrapper -->

</div>
<!-- End of Page Wrapper -->

<!-- Scroll to Top Button-->
<a class="scroll-to-top rounded" href="#page-top">
  <i class="fas fa-angle-up"></i>
</a>



  <!-- Modal -->
  <div class="modal fade" id="addcustomers" tabindex="-1" role="dialog" aria-labelledby="addcustomers" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 login-sec">
          <h5 class="modal-title" id="addcustomers">Add Customers</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      <form>
        <div class="modal-body">
          <div class="form-group">
              <label for="uname">User Name</label>
              <input type="text" class="form-control" id="uname">
              
            </div>
        <div class="form-group">
              <label for="Pn">Phone Number</label>
              <input type="text" class="form-control" id="Pnumber">
            </div>
            <div class="form-group">
              <label for="cemail">Email</label>
              <input type="text" class="form-control" id="cemail">
            </div>
            <div class="form-group">
              <label for="add">Address</label>
              <textarea class="form-control" id="address" rows="3"></textarea>
    
            </div>
        
          </div>
       </form>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </div>
  </div>
  <!--Modal End-->
  
  
  <!--edit modal-->
  <div class="modal fade" id="customereditModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header border-bottom-0 login-sec">
          <h5 class="modal-title" id="exampleModalLabel">Edit Customers</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      <form>
        <div class="modal-body">
          <div class="form-group">
              <label for="user_name">User Name</label>
              <input type="text" class="form-control" id="user_name">
              
            </div>
            <div class="form-group">
              <label for="phone">Phone No</label>
              <input type="text" class="form-control" id="phone">
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input type="Email" class="form-control" id="email">
            </div>
            <div class="form-group">
              <label for="address">Address</label>
              <textarea class="form-control" id="address" rows="3"></textarea>
            </div>
          </div>
       </form>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Update</button>
        </div>
      </div>
    </div>
  </div>
  <!--edit modal end-->  
  